module.exports = __webpack_public_path__ + "static/lazer.82d22d59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/lazer.jpg
// module id = 448
// module chunks = 35783957827783 172322841747965